import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

import { CompanyService } from '@app/shared/services/company.service';
import { IFBInvitation, IFBInvitations } from '@app/models/invitations';

@Injectable({
  providedIn: 'root'
})
export class InvitationResource {
  constructor(
    private companyService: CompanyService,
    private http: HttpClient
  ) {}

  private get companyId(): string {
    return this.companyService.data.id;
  }

  private url(): string {
    return `https://${environment.API_BASE}/v1/companies/${this.companyId}/invitations`;
  }

  save(body: IFBInvitations) {
    return this.http.post<IFBInvitations>(this.url(), body);
  }

  // save and saveSingle are the same endpoint and get differentiated based on the body.
  // Hopefully in the future we will remove the non-single endpoint
  saveSingle(body: IFBInvitation) {
    return this.http.post<void>(`${this.url()}`, body);
  }

  delete(userId: string) {
    return this.http.delete<void>(`${this.url()}/${userId}`);
  }
}
